<div
  #contentScroller
  (scroll)="scroller?.check()"
  class="scrollbarHide scroller"
  [class]="fadeOutClass$ | async"
>
  <div #content class="content">
    <ng-content></ng-content>
  </div>
</div>

<button
  *ngIf="(scroller?.canScroll$ | async)?.left"
  type="button"
  class="
    scrollButton
    overlappingAnchorTopLeft
  "
  (click)="scroller?.scrollLeft()"
>
  <svg style="rotate: 180deg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7625 5L14 6.7625L19.725 12.5L14 18.2375L15.7625 20L23.2625 12.5L15.7625 5Z" fill="#B0B0B0"/>
  </svg>
</button>

<button
  *ngIf="(scroller?.canScroll$ | async)?.right"
  type="button"
  class="
    scrollButton
    overlappingAnchorTopRight
  "
  (click)="scroller?.scrollRight()"
>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7625 5L14 6.7625L19.725 12.5L14 18.2375L15.7625 20L23.2625 12.5L15.7625 5Z" fill="#B0B0B0"/>
  </svg>
</button>

